import React from 'react';
import { Box, Typography } from '@mui/material';

const Properties: React.FC = () => {
  return (
    <Box p={3}>
      <Typography variant="h5">Properties</Typography>
      {/* Add property management functionality here */}
    </Box>
  );
};

export default Properties;
